'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSelectedElements = exports.getSelectedElementIds = undefined;

var _reselect = require('reselect');

var _elementSelector = require('../elementSelector');

// Lib
var getSelectedElementIds = exports.getSelectedElementIds = function getSelectedElementIds(state) {
    return state.getIn(['app', 'selection', 'ids']);
};

// Selectors
var getSelectedElements = exports.getSelectedElements = (0, _reselect.createSelector)(getSelectedElementIds, _elementSelector.getElements, function (selectedElementIds, elements) {
    return selectedElementIds.map(function (id) {
        return elements.get(id);
    });
});


//////////////////
// WEBPACK FOOTER
// ./src/client/element/selection/selectedElementsSelector.js
// module id = 127
// module chunks = 0